import script from "./expoundAnswerAddEditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./expoundAnswerAddEditDialog.vue?vue&type=script&setup=true&lang=js"

import "./expoundAnswerAddEditDialog.vue?vue&type=style&index=0&id=2dc6b6df&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc6b6df"]])

export default __exports__